import { useState } from 'react'
import { useFreebets } from '@hooks/queries/useFreebets'
import { useFreebetPlay } from '@hooks/betting/useFreebetPlay'
import FreebetsList from './FreebetsList'
import FreebetRowCard from './FreebetRowCard'

const PAGE_SIZE = 15

// Active Freebets tab: the placeable freebet grant list (useFreebets ['ACTIVE'])
// with a Play button per row. All Play logic lives in useFreebetPlay. History +
// Purchases are bets-based (BetsHistoryTab), not this list.
const FreebetsListTab = ({ statuses, headerElements, emptyMessage }) => {
  // fetchFreebets (ROOT) is 0-indexed — first page is 0. We keep the state
  // 0-indexed to match the wire, and offset by 1 only for the 1-indexed
  // Pagination UI below.
  const [page, setPage] = useState(0)

  const { data, isPending, isError } = useFreebets({ status: statuses, page, pageSize: PAGE_SIZE })
  const rows = data?.rows ?? []

  const { onPlay, isPlayDisabled } = useFreebetPlay()

  return (
    <FreebetsList
      headerElements={headerElements}
      rows={rows}
      renderCard={(row, index) => (
        <FreebetRowCard
          key={row.id ?? index}
          data={row}
          onPlay={onPlay}
          playDisabled={isPlayDisabled(row)}
        />
      )}
      isPending={isPending}
      isError={isError}
      emptyMessage={emptyMessage}
      // activeCount is ROOT's count for the queried status filter (pagination total).
      total={data?.activeCount}
      pageSize={PAGE_SIZE}
      currentPage={page + 1}
      onPageChange={(uiPage) => setPage(uiPage - 1)}
    />
  )
}

export default FreebetsListTab
